export const groupOptions = [
  {
    groupingOfReportExtractID: 1,
    groupingOfReportExtractDescription: 'REIT',
    isDefault: true,
  },
  {
    groupingOfReportExtractID: 2,
    groupingOfReportExtractDescription: 'Report Period',
    isDefault: true,
  },
  {
    groupingOfReportExtractID: 3,
    groupingOfReportExtractDescription: 'Report Type',
    isDefault: false,
  },
];
